// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table__body[data-v-fcbbc47a]{width:100%;table-layout:fixed !important}.text_overflow[data-v-fcbbc47a]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:400px}.pup_card[data-v-fcbbc47a]{width:200px;border-radius:5px;padding:5px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:16px}[data-v-fcbbc47a] .el-dialog__body{padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
